import { render, staticRenderFns } from "./GestionRecetas.vue?vue&type=template&id=a2b614b8&scoped=true"
import script from "./GestionRecetas.vue?vue&type=script&lang=js"
export * from "./GestionRecetas.vue?vue&type=script&lang=js"
import style0 from "./GestionRecetas.vue?vue&type=style&index=0&id=a2b614b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2b614b8",
  null
  
)

export default component.exports